import React, { useMemo } from 'react';
import isSameDay from 'date-fns/isSameDay';
import isToday from 'date-fns/isToday';
import format from 'date-fns/format';
import { DeviceSizes } from 'shared/enums/DeviceSizes';
import { Flex, Box, useConst, useMediaQuery } from '@televet/kibble-ui/build/chakra';
import { Text } from '@televet/kibble-ui/build/components/Text';

interface IDayIndicatorProps {
  dayLabel: string;
  dayNumber: string | number;
  date: Date;
  currentDay: Date;
  onDayClick: (date: Date) => void;
}

const DayIndicator = ({ dayNumber, date, currentDay, onDayClick }: IDayIndicatorProps): JSX.Element => {
  const [isMobileWidth] = useMediaQuery('(' + DeviceSizes.MobileMaxWidth + ')');
  const _isToday = useConst(isToday(date));
  const isCurrentDay = useMemo(() => isSameDay(date, currentDay), [currentDay, date]);

  const onClick = (): void => onDayClick(date);

  return (
    <Box h="100%">
      <Flex
        bgColor={isCurrentDay || _isToday ? 'background.alpha' : 'transparent'}
        flexDir="column"
        justify="center"
        h="100%"
        px={isMobileWidth ? 2 : 4}
        py={isMobileWidth ? 0 : 4}
        textAlign="center"
        borderRadius="base"
        onClick={onClick}
        cursor="pointer"
        boxSizing="border-box"
        borderBottomWidth={isCurrentDay || _isToday ? '3px' : 0}
        {...(_isToday && { borderBottomColor: 'border.danger' })}
        {...(isCurrentDay && { borderBottomColor: 'border.info', fontWeight: 'semibold' })}
      >
        <Text size="xs" {...(isCurrentDay && { color: 'text.info' })}>
          {format(date, 'EEE')}
        </Text>
        <Flex w="40px" justify="center">
          <Text size="sm" {...(isCurrentDay && { color: 'text.info' })}>
            {dayNumber}
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
};

export default DayIndicator;
